import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isEmpty, toInteger} from 'lodash';
import EditableText from './EditableText';
import {updateForSession} from 'actionCreators/comparableSales';
import editIcon from 'images/editIcon.svg';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import NumberValidator from 'lib/NumberValidator';
import DisclaimerMark from 'components/DisclaimerMark/DisclaimerMark';
import SalePrice from 'components/SalePrice';
import ObjectValidator from 'lib/ObjectValidator';
import {getPopupProps} from 'lib/EditableFieldUtil';

const fieldsToCheck = ['salePrice'];

function runValidators(property, value) {
  const propToCheck = {salePrice: property.salePrice?.toString() ?? ''};
  if (propToCheck.salePrice === '0') {
    propToCheck.salePrice = '';
  }
  const changeValidator = ObjectValidator.hasObjectFieldChanged(propToCheck, fieldsToCheck);
  return changeValidator(value) && (isEmpty(value) || NumberValidator.isValidInteger(value, 8));
}

const mapStateToProps = (state, ownProps) => ({
  className: 'editable-sale-price',
  editIsEnabled: true,
  editStyle: {
    width: '7em',
  },
  onChangeValidator: (value) => NumberValidator.isValidInteger(value, 8),
  popupProps: getPopupProps({dataPoint: 'Sale Price'}),
  rawText: (ownProps.property.salePrice || '').toString(),
  renderedText: (
    <SalePrice
      isAgentsAdvice={ownProps.property.isAgentsAdvice}
      isPriceWithheld={ownProps.property.isPriceWithheld}
      salePrice={ownProps.property.salePrice}
      style={{borderBottom: '1px solid rgba(0, 0, 0, 0.15)'}}
    >
      {ownProps.showEdited && (
        <DisclaimerMark/>
      )}
      {ownProps.showEditIcon && (
        <img alt="edit-icon"
             style={{
               display: 'inline-block',
               height: '1.5rem',
               marginLeft: '0.5rem',
               verticalAlign: 'text-bottom',
               fontSize: '.78571429rem',
               width: '16px'
             }}
             src={editIcon}/>
      )}
    </SalePrice>
  ),
  renderedTextRef: ownProps.renderedTextRef,
  reportType: state.reportType.value,
  targetPropertyId: state.propertyDetail.propertyId,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onUpdateData: ({rawText}) => {
    dispatch(updateForSession({
      propertyId: ownProps.property.propertyId,
      keyPath: 'salePrice',
      value: toInteger(rawText),
    }, true));
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  onUpdateData: ({rawText}) => {
    if (runValidators(ownProps.property, rawText)) {
      dispatchProps.onUpdateData({rawText});
      AnalyticsGateway.sendEvent({
        eventName: 'Update Sale Price',
        properties: [
          {label: 'Report Type', value: stateProps.reportType},
          {label: 'Page', value: 'Customise Report'},
          {label: 'Property ID', value: stateProps.targetPropertyId},
          {label: 'Comparable Property ID', value: ownProps.property.propertyId},
          {label: 'New Sale Price', value: toInteger(rawText)},
        ],
      });
    }
  }
});

const EditableSalePriceContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditableText);

EditableSalePriceContainer.propTypes = {
  property: PropTypes.object,
  renderedTextRef: PropTypes.any,
  showEdited: PropTypes.bool,
  showEditIcon: PropTypes.bool,
};

EditableSalePriceContainer.defaultProps = {
  showEdited: false,
  showEditIcon: true,
};

export default EditableSalePriceContainer;